import { html, LitElement } from 'lit';

export default class FooterWebComponent extends LitElement {
  createRenderRoot() {
    return this;
  }

  static properties = {
    name: { type: String },
    data: { type: Object },
    basepath: { type: String },
    program_id: { type: String }
  };

  constructor() {
    super();
    this.name = 'Footer Web Component';
    this.data = {};
    this.dataStatic = [
      {
        text: 'Wafer sweet apple pie'
      },
      {
        text: 'Wafer sweet apple pie'
      },
      {
        text: 'Wafer sweet apple pie'
      },
      {
        text: 'Wafer sweet apple pie'
      },
      {
        text: 'Wafer sweet apple pie'
      }
    ];
    this.basepath = '';
    this.program_id = '';
  }

  async connectedCallback() {
    super.connectedCallback();

    // console.log(this.data, 'BUENAS BUENAS');
  }

  render() {
    const { data, basepath, program_id } = this;

    const { footer_links, logofooter, copyright, bullet } = data || {};

    let links;

    const bulletImg = bullet !== null ? String(bullet.url).replace('/uploads/', '') : null;
    const logo = logofooter !== null ? String(logofooter.url).replace('/uploads/', '') || '' : null;

    if (footer_links.length ?? 0) {
      links = html`
        ${footer_links.map(
    (item) => html`
            <li>
              <!-- <div class="circle"></div> -->
              <img
                class="icon"
                src="${basepath}/dist/${program_id}/img/${bulletImg}"
                alt="${bullet.alternativeText || 'Bullet icon'}"
              />
              <a
                href="${item.url}"
                target="${item.opens_in_new_tab ? '_blank' : ''}"
                rel="noopener noreferrer"
                class="lang"
                key="link_1"
              >
                ${item.label}
              </a>
            </li>
          `
  )}
      `;
    } else {
      links = html`
        ${this.dataStatic.map(
    (child) => html`
            <li>
              <div class="circle"></div>
              <a target="_blank" rel="noopener noreferrer" class="lang" key="link_1">
                ${child.text}
              </a>
            </li>
          `
  )}
      `;
    }

    return html`
      <section class="footer-component">
        <!-- <div class="footer-links">

          <ul>
            ${links}
          </ul>
        </div> -->

        <br />

        <!-- <img src="${logofooter !== null
    ? `${basepath}/dist/${program_id}/img/${logo}`
    : null}" alt=""> -->

        ${copyright[0].children[0].text !== ''
    ? copyright?.map(
      (item) => html`
                ${item.children.map(
    (child) => html` <label class="lang" key="copy"> ${child.text} </label> `
  )}
              `
    )
    : html` <label class="lang" key="copy"> Copyright 2025 - Lorem Ipsum </label> `}

        <br />
        <br />
      </section>
    `;
  }
}

customElements.define('footer-webcomponent', FooterWebComponent);
